import { render, staticRenderFns } from "./qrCodeLogo.vue?vue&type=template&id=5208a55a&scoped=true"
import script from "./qrCodeLogo.vue?vue&type=script&lang=js"
export * from "./qrCodeLogo.vue?vue&type=script&lang=js"
import style0 from "./qrCodeLogo.vue?vue&type=style&index=0&id=5208a55a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5208a55a",
  null
  
)

export default component.exports